<template>
  <div class="center">
    <div class="center-header title">示范企业概况</div>
    <div class="center-top">
      <div class="demonstration">
        <div class="top-text font-fam-s font-size18">接入果园</div>
        <div class="text-num">
          <span class="text-size font-fam-o">{{orchardOverview.baseNum}}</span>
          <span class="text-nuits unit font-size16">个</span>
        </div>
        <div class="state">
          <span class="triangle"></span>
          <span class="goUp-color font-size16">5.21%</span>
        </div>
      </div>
      <div class="demonstration">
        <div class="top-text font-fam-s font-size18">种植面积</div>
        <div class="text-num">
          <span class="text-size font-fam-o">{{orchardOverview.plantArea}}</span>
          <span class="text-nuits unit font-size16">亩</span>
        </div>
        <div class="state green">
          <span class="triangle"></span>
          <span class="goUp-color font-size16">5.21%</span>
        </div>
      </div>
      <div class="demonstration">
        <div class="top-text font-fam-s font-size18">带动就业</div>
        <div class="text-num">
          <span class="text-size font-fam-o">{{orchardOverview.driveWorkNum}}</span>
          <span class="text-nuits unit font-size16">人</span>
        </div>
        <div class="state green">
          <span class="triangle"></span>
          <span class="goUp-color font-size16">50%</span>
        </div>
      </div>
      <div class="demonstration">
        <div class="top-text font-fam-s font-size18">增加收入</div>
        <div class="text-num">
          <span class="text-size font-fam-o">{{orchardOverview.increaseIncome}}</span>
          <span class="text-nuits unit font-size16">元/人</span>
        </div>
        <div class="state green">
          <span class="triangle"></span>
          <span class="goUp-color font-size16">58%</span>
        </div>
      </div>
    </div>
    <div class="center-map">
      <img class="map-img" src="../../assets/bgIcon/map.png" alt />
      <div class="weather">
        <div class="temperatures">
          <span>{{weatherData.tmp}}</span>
          <span>℃</span>
        </div>
        <div class="weather-state">
          <span>{{weatherData.condTxt}}</span>
          <img class="weather-icon" :src="getImgUrl(weatherData.condCode)" alt />
        </div>
      </div>
      <div class="dragonFruit-info" @click.stop="ClickDragon1">
        <img src="../../assets/bgIcon/dragonFruit.png" alt />
      </div>
      <div id="shadow" class="shadowDom1">
        <div class="title-shadow">
          <span>一丰农业</span>
          <span class="close" @click="close">x</span>
        </div>
        <div class="shadow_info">
          <div class="img_div">
            <img src="../../assets/bgIcon/huolongguo.jpg" alt />
          </div>
          <div class="info">
            <div>
              <span>面积：</span>
              <span>{{dragonData.plantAcreage}}亩</span>
            </div>
            <div>
              <span>员工：</span>
              <span>{{dragonData.staffNum}}人</span>
            </div>
            <div>
              <span>地址：</span>
              <span :title="dragonData.address">{{dragonData.address}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="production">
      <div class="title production-title">历年产销概况</div>
      <div id="production" ref="productionEcharts"></div>
    </div>
  </div>
</template>
<script>
var echarts = require("echarts");
export default {
  data() {
    return {
      orchardOverview: [],
      varietyYear: {
        data: {
          outputData: [],
          salesData: []
        },
        yearList: []
      },
      dragonData: [],
      weatherData: []
    };
  },
  async mounted() {
    await this.$axios
      .get("/bigdata/index/getBaseSituationData")
      .then(res => {
        this.orchardOverview = res.data.situationData;
      })
      .catch(res => {
        console.log(res);
      });
    await this.$axios
      .get("/bigdata/index/getMapData")
      .then(res => {
        console.log(res.data);
        this.varietyYear.data.outputData = res.data.outputSalesData.outputData;
        this.varietyYear.data.salesData = res.data.outputSalesData.salesData;
        this.varietyYear.yearList = res.data.outputSalesData.yearList;
        this.weatherData = res.data.weatherData;
      })
      .catch(res => {
        console.log(res);
      });
    this.ProductionEcharts();
    this.clickWindow();
  },
  methods: {
    ProductionEcharts() {
      let myCharts = this.$echarts.init(this.$refs.productionEcharts);
      let output = this.varietyYear.data.outputData;
      let sales = this.varietyYear.data.salesData;
      let years = this.varietyYear.yearList;
      myCharts.setOption({
        grid: {
          left: "8%",
          right: "6%",
          bottom: "5%",
          containLabel: true
        },
        legend: {
          data: ["产量", "销量"],
          top: 40,
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: 12, //字体大小
            color: "#FFFFFFFF" //字体颜色
          }
        },
        tooltip: {},
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.7)",
              width: 1
            }
          },
          data: years
        },
        yAxis: {
          name: "(吨)",
          nameTextStyle: {
            color: "rgba(255,255,255,0.5)",
            fontSize: 12,
            padding: [0, 0, 0, -40]
          },
          max: 1400,
          min: 1000,
          splitNumber: 5,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#092439"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "rgba(255,255,255,0.5)",
              fontWeight: "Regular",
              fontSize: 12
            }
          }
        },
        series: [
          {
            name: "产量",
            type: "bar",
            barGap: 0,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#E9F37D" }, //柱图渐变色
                  { offset: 0.5, color: "#E8DD61" }, //柱图渐变色
                  { offset: 1, color: "#E8DD61" } //柱图渐变色
                ])
              },
              fontSize: 14
            },
            data: output
          },
          {
            name: "销量",
            type: "bar",
            barGap: 0,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#61FEE6" }, //柱图渐变色
                  { offset: 0.5, color: "#00EAFF" }, //柱图渐变色
                  { offset: 1, color: "#00EAFF" } //柱图渐变色
                ])
              },
              fontSize: 14
            },
            data: sales
          }
        ]
      });
    },
    clickWindow() {
      let bodyObj = document.documentElement || document.body;
      let shadowDom = document.getElementById("shadow");
      bodyObj.onclick = () => {
        shadowDom.style.display = "none";
      };
    },
    close() {
      let shadowDom = document.getElementById("shadow");
      shadowDom.className = "shadowDom3";
      shadowDom.style.display = "none";
    },
    ClickDragon1() {
      let shadowDom = document.getElementById("shadow");
      let cl = document.getElementById("shadow").className;
      if (cl) {
        shadowDom.classList.remove(cl);
      }
      shadowDom.className = "shadowDom1";
      shadowDom.style.display = "block";
      this.$axios
        .get("/bigdata/index/getMapData")
        .then(res => {
          this.dragonData = res.data.baseMapData[0];
        })
        .catch(res => {
          console.log(res);
        });
    },

    getImgUrl(icons) {
      return require("@/assets/weather/" + icons + ".png");
    }
  }
};
</script>
<style lang='scss' scoped>
.center {
  position: absolute;
  left: 545px;
  .center-header {
    padding: 10px 0 10px 10px;
  }
  .center-top {
    width: 100%;
    display: flex;
    margin-bottom: 17px;
    .demonstration {
      width: 190px;
      height: 135px;
      background: url("../../assets/bgIcon/ellipse.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 24px;
      text-align: center;
      .top-text {
        line-height: 28px;
        background-image: -webkit-linear-gradient(top, #fffefeff, #26bea7ff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 11px 0 14px 0;
      }
      .text-size {
        font-size: 40px;
        line-height: 30px;
      }
      .state,
      .green {
        position: relative;
        .triangle {
          width: 0;
          height: 0;
          border: 8px solid;
          border-radius: 5px;
          position: absolute;

          left: 28%;
        }
        .goUp-color {
          font-family: SourceHanSansCN-Medium;
          font-weight: Medium;
          // line-height: 30px;
        }
      }
      .state {
        color: #ff7f95;
        .triangle {
          top: 41%;
          border-color: #ff7f95 transparent transparent transparent;
        }
      }
      .green {
        color: #7fffa0;
        .triangle {
          top: 9%;
          border-color: transparent transparent #7fffa0;
        }
      }
    }
  }
  .center-map {
    width: 748px;
    height: 706px;
    margin: 0 37px 0 14px;
    position: relative;
    .map-img {
      width: 100%;
      height: 100%;
    }
    .weather {
      position: absolute;
      left: 0px;
      top: 0;
      .weather-state {
        display: flex;
        align-items: center;
      }
      .temperatures span:first-child {
        font-size: 30px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #7feeff;
        line-height: 30px;
      }
      .temperatures span:nth-child(2) {
        font-size: 20px;
        font-family: SourceHanSansCN-Medium;
        font-weight: Medium;
        color: #ffffff;
        line-height: 30px;
      }
      .weather-state span:first-child {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
      }
      .weather-icon {
        width: 34px;
        height: 28px;
      }
    }
    .dragonFruit-info {
      width: 107px;
      height: 153px;
      position: absolute;
      top: 12%;
      left: 35%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    #shadow {
      width: 259px;
      height: 144px;
      background: url(../../assets/bgIcon/info.png) no-repeat;
      background-size: 100% 100%;
      padding: 0 10px;
      box-sizing: border-box;
      display: none;

      .title-shadow {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
        padding: 12px 0 10px 0;
        display: flex;
        justify-content: space-between;
        .close {
          font-size: 18px;
          cursor: pointer;
        }
      }
      .shadow_info {
        display: flex;
        align-items: center;
        .img_div {
          width: 90px;
          height: 80px;
          background: rgba(186, 223, 255, 1);
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          width: 120px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 25px;
          margin-left: 8px;
          div {
            width: 130px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .shadowDom1 {
      position: absolute;
      top: 130px;
      left: 350px;
    }
  }
  .production {
    width: 300px;
    height: 260px;
    background: url("../../assets/bgIcon/production.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 40px;
    top: 664px;
    padding-top: 15px;
  }
  #production {
    width: 100%;
    height: 230px;
  }
  .production-title {
    position: absolute;
    top: 20px;
    left: 18%;
  }
}
</style>